import { useFilterContext } from '@/context';

// Earliest date (YYYY-MM-DD) each audience data type is available from.
export const DATA_AVAILABILITY = {
  players: { label: 'Players', availableFrom: '2017-01-01' },
  uniques: { label: 'Uniques', availableFrom: '2026-09-01' },
  device: { label: 'Device', availableFrom: '2021-05-23' },
  gender: { label: 'Gender', availableFrom: '2025-10-02' },
  age: { label: 'Age', availableFrom: '2025-10-02' },
  location: { label: 'Location', availableFrom: '2014-04-01' },
  uniqueOverview: { label: 'Unique', availableFrom: '2019-09-03' },
} as const;

export type DataAvailabilityType = keyof typeof DATA_AVAILABILITY;

export type DataAvailabilityState = {
  /** Selected range starts before this data type exists. */
  showBanner: boolean;
  /** The whole selected range ends before this data type exists. */
  hideContent: boolean;
  /** Query start, moved forward to the first day this data type exists. */
  queryFrom: string;
};

export const getDataAvailability = (
  dataType: DataAvailabilityType,
  from: string,
  to: string
): DataAvailabilityState => {
  const { availableFrom } = DATA_AVAILABILITY[dataType];

  return {
    showBanner: from < availableFrom,
    hideContent: to < availableFrom,
    queryFrom: from < availableFrom ? availableFrom : from,
  };
};

/**
 * Availability of `dataType` for a range. Uses `from` and `to` when given, otherwise the page filter.
 */
const useIsBeforeDataAvailability = (
  dataType: DataAvailabilityType,
  from?: string,
  to?: string
): DataAvailabilityState => {
  const { filters } = useFilterContext();

  return getDataAvailability(
    dataType,
    from ?? filters.dateRange.from,
    to ?? filters.dateRange.to
  );
};

export default useIsBeforeDataAvailability;
